import { Tabs } from 'react-aria-components';
import { Heading, Paragraph } from '@hungryroot/ramen';
import { useGroceryPreferences } from '../hooks/useGroceryPreferences';
import {
  generateTabId,
  GroceryCategoryTabList,
} from './GroceryCategoryTabList';
import { GroceryCategoryTabPanel } from './GroceryCategoryTabPanel';
import styles from './GroceryPreferences.module.css';

export function GroceryPreferences() {
  const { groceries, selectedCategory, onChangeCategory, isGroceriesLoading } =
    useGroceryPreferences();

  return (
    <div>
      <div className={styles['heading-text']}>
        <Heading variant="H1" as="h2">
          Grocery Preferences
        </Heading>
        <Paragraph className={styles.subheading} variant="lead">
          Let us know if you want something whenever it's available, if you'd
          like it sometimes, or if you'd never like to receive it.
        </Paragraph>
      </div>

      {selectedCategory ? (
        <Tabs
          className={styles.tabs}
          selectedKey={generateTabId(selectedCategory)}
          onSelectionChange={onChangeCategory}
        >
          <GroceryCategoryTabList selectedCategory={selectedCategory} />

          <GroceryCategoryTabPanel
            selectedCategory={selectedCategory}
            groceries={groceries}
            isGroceriesLoading={isGroceriesLoading}
          />
        </Tabs>
      ) : null}
    </div>
  );
}
